<template>
  <div class="bigBox">
    <div style="display: flex">
      <div class="header">
        <el-select
          v-model="listQuery.progressStatus"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model.trim="listQuery.keyWord"
          placeholder="请输入竞买名称/项目编号"
          clearable
        ></el-input>
        <div class="search" @click="search()">搜索</div>
      </div>
    </div>
    <div class="content" v-if="total > 0">
      <div
        class="list"
        v-for="(item, index) in list"
        :key="index"
        @click="goDetail(item)"
      >
        <img
          :src="item.auctionPictureUrl"
          alt=""
          class="img"
          mode="aspectFill"
        />

        <div class="time bgGreen" v-if="item.progressStatus == 3">
          距开始：{{ item.time ? item.time : "--" }}
        </div>
        <div class="time bgRed" v-if="item.progressStatus == 4">
          距结束：{{ item.time ? item.time : "--" }}
        </div>
        <div class="time bgHui" v-if="item.progressStatus == 5 || item.progressStatus == 6">已结束</div>
        <div class="title">{{ item.auctionProjectName }}</div>
        <div class="flexDiv">
          <div class="lable">项目编号：</div>
          <div class="value">{{ item.auctionProjectCode }}</div>
        </div>
        <div class="flexDiv">
          <div class="lable">限高价：</div>
          <div class="money">￥{{ (item.startingPrice / 100).toFixed(2) }}</div>
          <div class="remarks" v-if="item.offerCount > 2">
            （{{ item.offerCount }}次出价）
          </div>
        </div>
        <div class="flexDiv">
          <div class="lable">开拍时间：</div>
          <div class="value">{{ item.auctionStartTime }}</div>
        </div>
        <!-- <div class="flexDiv">
          <div class="lable">参加人数：</div>
          <div class="value">{{ item.signQuantity }}人</div>
        </div> -->
        <div class="state bgRed" v-if="item.progressStatus == 4">正在进行</div>
        <div class="state bgGreen" v-if="item.progressStatus == 3">
          即将开始
        </div>
      </div>
    </div>

    <div class="footer" v-if="total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.current"
        background
        :page-size="listQuery.size"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 没有数据 -->
    <noInfo v-else></noInfo>
  </div>
</template>

<script>
import noInfo from "@/components/noInfo.vue";
import { auctionProjectHomePage,getAllHomePage,auctionProjectHomePageReflash } from "@/api/auction/index.js";
import { imageEchoIndex,imageEchoIndex2 } from "@/api/index.js";
export default {
  components: {
    noInfo,
  },
  data() {
    return {
      list: [],
      listQuery: {
        size: 6,
        current: 1,
        keyWord: "",
        progressStatus: null,
        projectType: 2,
      },
      options: [
        { value: null, label: "全部" },
        { value: 3, label: "即将开始" },
        { value: 4, label: "正在进行" },
        { value: 5, label: "已结束" },
      ],
      total: 0,
      timer: [null, null, null, null, null, null],
      timer1: null,
      // timer2: null,
    };
  },
  mounted() {
    this.auctionProjectHomePage();
    this.timer1 = setInterval(()=>{this.getRefreshList()}, 20000);
  },
  beforeDestroy() {
    this.clearInterval();
    window.clearInterval(this.timer1)
    // this.timer = null;
    // clearInterval(this.timer1);
    // this.timer1 = null;
  },
  methods: {
    getTime(time, progressStatus, index) {
      // 将日期时间字符串转换为Date对象
      let date1 = new Date(time);
      let date2 = new Date();
      let diff = 0;
      diff = date1.getTime() - date2.getTime();
      // console.log(diff,"---===1111")
      if(diff<1000) {
        this.clearInterval()
        this.getauctionProjectHomePageReflash();
      }
      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.round((diff % (1000 * 60)) / 1000);
      // hours = hours > 9 ? hours : "0" + hours;
      // minutes = minutes > 9 ? hours : "0" + minutes;
      // seconds = seconds > 9 ? seconds : "0" + seconds;
      // let timeText = hours + ":" + minutes + ":" + seconds;
      let timeText = days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
      if (this.list[index].time && diff>0) {
        this.list[index].time = timeText;
      } else {
        this.list[index].time = '--';
      }
    },
    setIntervalTime(time, progressStatus, index) {
      // this.getTime(time, progressStatus, index);
      if (!this.timer[index]) {
        this.timer[index] = setInterval(() => {
          this.getTime(time, progressStatus, index);
        }, 1000);
      }
    },
    clearInterval() {
      for (let i = 0; i < 6; i++) {
        if (this.timer[i]) {
          window.clearInterval(this.timer[i]);
        }
      }
      this.timer = [null,null,null,null,null,null]
      
    },
    handleCurrentChange(current) {
      this.listQuery.current = current;
      this.clearInterval();
      this.auctionProjectHomePage();
    },
    search() {
      this.listQuery.current = 1;
      // window.clearInterval(this.timer);
      // this.list = []
      this.clearInterval();
      this.auctionProjectHomePage();
    },
    // 用于解决竞买多次出价后 页面的报价次数能够及时刷新
    getRefreshList() {
      getAllHomePage(this.listQuery).then(res=>{
        if (res.data.code == 1) {
          let data = res.data.data || {};
          let dataArr = data.records || [];
          dataArr.forEach(item=>{
            this.list.forEach(val=>{
              if(item.auctionProjectId === val.auctionProjectId) {
                this.$nextTick(()=>{
                  val.offerCount = item.offerCount
                  val.progressStatus = item.progressStatus
                })
                
              }
            })
          })
        }
      })
    },
    auctionProjectHomePage() {
      this.list = [];
      auctionProjectHomePage(this.listQuery).then((res) => {
        if (res.data.code == 1) {
          let data = res.data.data || {};
          this.list = data.records || [];
          this.total = data.total || 0;
          this.list = this.list.map((item) => {
            return { ...item, time: "--" };
          });
          this.list.forEach((item, index) => {
            let imgs = item.auctionPictureUrl.split(",");
            imageEchoIndex2({ imgPath: imgs[0] }).then((res) => {
              item.auctionPictureUrl = res.data.data.imageCode;
            });
          });
          this.list.forEach((item, index) => {
            if (item.progressStatus == 3 || item.progressStatus == 4) {
              let time =
                item.progressStatus == 3
                  ? item.auctionStartTime
                  : item.finallyAuctionEndTime;
              if (time) {
                this.setIntervalTime(time, item.progressStatus, index);
              }
            }
          });
        }
      });
    },
    getauctionProjectHomePageReflash() {
      auctionProjectHomePageReflash(this.listQuery).then(res=>{
        if(res.data.code==1) {
          let data = res.data.data || {};
          let dataArr = data.records || [];
          this.total = data.total || 0;
          dataArr.forEach(val=>{
            this.list.forEach((item,index)=>{
              if(item.auctionProjectId === val.auctionProjectId) {
                item.progressStatus = val.progressStatus
                if (item.progressStatus == 3 || item.progressStatus == 4) {
                let time =
                  item.progressStatus == 3
                    ? item.auctionStartTime
                    : item.finallyAuctionEndTime;
                  if (time) {
                    this.setIntervalTime(time, item.progressStatus, index);
                  }
              }
              }
            })
          })
        }
      })
    },
    goDetail(item) {
      this.$router.push({
        path: "/home/competitionBuyDetail",
        query: {
          auctionProjectId: item.auctionProjectId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bigBox {
  flex: 1;
  padding-top: 57px;
  padding-bottom: 57px;
  width: 1200px;
  margin: 0 auto;
  /deep/.el-input__inner {
    border: none !important;
  }
  .search {
    width: 90px;
    height: 40px;
    line-height: 40px;
    // border-radius: 6px;
    text-align: center;
    background: #4edeae;
    margin-left: 15px;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
  }
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 490px;
    margin: 0 auto;
    margin-bottom: 26px;
    border: 1px solid #dcdfe6;
  }
  .content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
    .list {
      width: 350px;
      height: 422px;
      border-radius: 10px;
      border: 1px solid #dcdfe6;
      margin: 24px;
      overflow: hidden;
      position: relative;
      .img {
        width: 350px;
        height: 222px;
        border-radius: 10px 10px 0px 0px;
      }
      .time {
        position: absolute;
        top: -1px;
        left: -1px;
        // width: 172px;
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        border-radius: 10px 0px 10px 0px;
        font-size: 16px;
        text-align: center;
        color: #fff;
      }
      .bgRed {
        background: #e53e3e;
      }
      .bgHui {
        background: #bfbfbf;
      }
      .bgGreen {
        background: #4edeae;
      }
      .title {
        width: 100%;
        font-size: 16px;
        color: #3d3d3d;
        padding-left: 15px;
        padding-top: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
        margin-bottom: 20px;
      }
      .flexDiv {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 15px;
        .lable {
          font-size: 14px;
          color: #5e5b5b;
          text-align: right;
          width: 86px;
          margin-right: 10px;
        }
        .value {
          font-size: 14px;
          color: #5e5b5b;
        }
        .money {
          color: #44dbab;
          font-size: 16px;
        }
        .remarks {
          color: #767676;
          font-size: 16px;
        }
      }
      .state {
        position: absolute;
        right: 0px;
        bottom: 14px;
        width: 109px;
        height: 40px;
        line-height: 40px;
        border-radius: 30px 0px 0px 30px;
        font-size: 16px;
        color: #fff;
        text-align: center;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/competitionBuy/index.vue